import * as React from "react";
const SvgPointcloudOnly = (props) => /* @__PURE__ */ React.createElement("svg", {
	id: "Punktmoln",
	xmlns: "http://www.w3.org/2000/svg",
	width: 139.66,
	height: 73.975,
	viewBox: "0 0 139.66 73.975",
	...props
}, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, "\r\n      .pointcloud-cls-1 {\r\n        fill: #3f3d56;\r\n      }\r\n\r\n      .pointcloud-cls-2 {\r\n        fill: #8f989a;\r\n      }\r\n\r\n      .pointcloud-cls-3 {\r\n        fill: #939d9e;\r\n      }\r\n\r\n      .pointcloud-cls-4 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .pointcloud-cls-5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .pointcloud-cls-6, .pointcloud-cls-7 {\r\n        fill: #747678;\r\n      }\r\n\r\n      .pointcloud-cls-7 {\r\n        font-size: 15px;\r\n        font-family: Montserrat-Regular, Montserrat;\r\n      }\r\n\r\n      .pointcloud-cls-8 {\r\n        fill: #707070;\r\n      }\r\n    ")), /* @__PURE__ */ React.createElement("path", {
	id: "Path_364",
	"data-name": "Path 364",
	className: "pointcloud-cls-1",
	d: "M476.557,562.186a.518.518,0,0,0-.518.518v20.675a.518.518,0,0,0,.518.518h3.51a.518.518,0,0,0,.518-.518V562.7a.518.518,0,0,0-.517-.518Z",
	transform: "translate(-423.16 -510.168)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_365",
	"data-name": "Path 365",
	className: "pointcloud-cls-1",
	d: "M694.4,562.186a.518.518,0,0,0-.518.518v20.675a.518.518,0,0,0,.518.518h3.51a.518.518,0,0,0,.518-.518V562.7a.518.518,0,0,0-.518-.518Z",
	transform: "translate(-611.813 -510.168)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_366",
	"data-name": "Path 366",
	className: "pointcloud-cls-1",
	d: "M490.184,252.218l-26.911-2.078,21.469,3.661,5.145-.89Z",
	transform: "translate(-391.203 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_367",
	"data-name": "Path 367",
	className: "pointcloud-cls-2",
	d: "M486.219,253.475l5.145-.89.051-.118.246.019-.3.693-5.145.89L464.75,250.14l6.362.759Z",
	transform: "translate(-392.483 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_368",
	"data-name": "Path 368",
	className: "pointcloud-cls-1",
	d: "M35.307,252.218,8.4,250.14,29.865,253.8l5.145-.89Z",
	transform: "translate(2.729 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_369",
	"data-name": "Path 369",
	className: "pointcloud-cls-2",
	d: "M27.65,253.475l5.145-.89.051-.118.246.019-.3.693-5.145.89L6.181,250.14l6.362.759Z",
	transform: "translate(4.647 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_370",
	"data-name": "Path 370",
	className: "pointcloud-cls-1",
	d: "M423.072,486.818l-2.276.1-20.847,8.8-1.193,1-3.782,3.166H383.1l-3.576-3.166-1.359-1.2-20-8.492-1.781-.2,5.936-2.869h.032c1.346-1.277,13-2.276,27.176-2.276s25.83,1,27.176,2.276h.131Z",
	transform: "translate(-319.541 -440.442)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_371",
	"data-name": "Path 371",
	className: "pointcloud-cls-1",
	d: "M344.9,430.375a1.109,1.109,0,0,0,.064-.369v-4.7a1.113,1.113,0,0,0-1.113-1.113H343.4a2.671,2.671,0,1,0-3.8,0h-.452a1.113,1.113,0,0,0-1.113,1.113v4.7a1.107,1.107,0,0,0,.145.549c-.336.059-.672.123-1.008.2a.921.921,0,0,0-.72.9v1.116a.923.923,0,0,0,.923.923H347.83v-2.77A23.8,23.8,0,0,0,344.9,430.375Z",
	transform: "translate(-302.275 -386.721)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_372",
	"data-name": "Path 372",
	className: "pointcloud-cls-1",
	d: "M792.386,430.75c-.336-.074-.672-.138-1.008-.2a1.107,1.107,0,0,0,.145-.549v-4.7a1.113,1.113,0,0,0-1.113-1.113h-.452a2.671,2.671,0,1,0-3.8,0h-.452a1.113,1.113,0,0,0-1.113,1.113V430a1.109,1.109,0,0,0,.064.369,23.8,23.8,0,0,0-2.933.546v2.77h10.455a.923.923,0,0,0,.923-.923v-1.116A.921.921,0,0,0,792.386,430.75Z",
	transform: "translate(-687.893 -386.721)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_373",
	"data-name": "Path 373",
	className: "pointcloud-cls-1",
	d: "M681.85,252.218l26.911-2.078L687.292,253.8l-5.145-.89Z",
	transform: "translate(-580.495 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_374",
	"data-name": "Path 374",
	className: "pointcloud-cls-1",
	d: "M581.058,610.9h-4.175a1.178,1.178,0,0,0-1.178,1.177v.91a1.177,1.177,0,0,0,.761,1.1,1.151,1.151,0,0,0-.267.738v.261a1.154,1.154,0,0,0,.495.947v3.473h4.551v-3.473a1.154,1.154,0,0,0,.495-.947v-.261a1.15,1.15,0,0,0-.267-.738,1.177,1.177,0,0,0,.761-1.1v-.91a1.178,1.178,0,0,0-1.178-1.178Z",
	transform: "translate(-509.473 -552.354)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_375",
	"data-name": "Path 375",
	className: "pointcloud-cls-3",
	d: "M563.876,671.475a.7.7,0,0,0-.7.7v5.616a.7.7,0,0,0,.7.7h8.485a.7.7,0,0,0,.7-.7v-5.616a.7.7,0,0,0-.7-.7Z",
	transform: "translate(-498.622 -604.814)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_376",
	"data-name": "Path 376",
	className: "pointcloud-cls-3",
	d: "M548.31,583.683l-3.782,3.166H532.656l-3.576-3.166h3.556l.155-.775a1,1,0,0,1,.985-.808H543.7a1,1,0,0,1,.985.808l.155.775Z",
	transform: "translate(-469.094 -527.414)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_51",
	"data-name": "Ellipse 51",
	className: "pointcloud-cls-1",
	cx: 2.77,
	cy: 2.77,
	r: 2.77,
	transform: "translate(66.727 67.4)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_52",
	"data-name": "Ellipse 52",
	className: "pointcloud-cls-4",
	cx: 1.583,
	cy: 1.583,
	r: 1.583,
	transform: "translate(67.914 68.587)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_377",
	"data-name": "Path 377",
	className: "pointcloud-cls-5",
	d: "M592.893,688.269a1.581,1.581,0,0,1-2.216,2.216,1.582,1.582,0,1,0,2.216-2.216Z",
	transform: "translate(-522.439 -619.358)"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1175",
	"data-name": "Rectangle 1175",
	className: "pointcloud-cls-4",
	width: 71.036,
	height: .453,
	transform: "translate(34.226 45.209)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_378",
	"data-name": "Path 378",
	className: "pointcloud-cls-2",
	d: "M688.769,253.475l-5.145-.89-.051-.118-.246.019.3.693,5.145.89,21.469-3.929-6.362.759Z",
	transform: "translate(-581.774 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_379",
	"data-name": "Path 379",
	className: "pointcloud-cls-1",
	d: "M226.973,252.218l26.911-2.078L232.414,253.8l-5.145-.89Z",
	transform: "translate(-186.563 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_380",
	"data-name": "Path 380",
	className: "pointcloud-cls-2",
	d: "M234.63,253.475l-5.145-.89-.051-.118-.246.019.3.693,5.145.89L256.1,250.14l-6.362.759Z",
	transform: "translate(-188.482 -216.626)"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1176",
	"data-name": "Rectangle 1176",
	className: "pointcloud-cls-4",
	width: 7.915,
	height: 1.583,
	transform: "translate(65.688 55.527)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_381",
	"data-name": "Path 381",
	className: "pointcloud-cls-4",
	d: "M235.384,173.935H211.392a3.214,3.214,0,0,0-3.211,3.211v12.738a3.214,3.214,0,0,0,3.211,3.211h23.992a3.214,3.214,0,0,0,3.211-3.211V177.146a3.214,3.214,0,0,0-3.211-3.211Z",
	transform: "translate(-190.19 -173.935)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_382",
	"data-name": "Path 382",
	className: "pointcloud-cls-5",
	d: "M228.279,193.435a.6.6,0,0,0-.6.6v12.738a.6.6,0,0,0,.6.6h23.992a.6.6,0,0,0,.6-.6V194.033a.6.6,0,0,0-.6-.6Z",
	transform: "translate(-207.077 -190.822)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_384",
	"data-name": "Path 384",
	className: "pointcloud-cls-4",
	d: "M513.384,173.935H489.392a3.214,3.214,0,0,0-3.211,3.211v12.738a3.214,3.214,0,0,0,3.211,3.211h23.992a3.214,3.214,0,0,0,3.211-3.211V177.146a3.215,3.215,0,0,0-3.211-3.211Z",
	transform: "translate(-430.944 -173.935)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_385",
	"data-name": "Path 385",
	className: "pointcloud-cls-5",
	d: "M506.279,193.435a.6.6,0,0,0-.6.6v12.738a.6.6,0,0,0,.6.6h23.992a.6.6,0,0,0,.6-.6V194.033a.6.6,0,0,0-.6-.6Z",
	transform: "translate(-447.83 -190.822)"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1177",
	"data-name": "Rectangle 1177",
	className: "pointcloud-cls-1",
	width: 139.66,
	height: .3,
	transform: "translate(0 73.674)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Icon_awesome-map",
	"data-name": "Icon awesome-map",
	className: "pointcloud-cls-6",
	d: "M0,4.039v7.233a.334.334,0,0,0,.458.31L3.342,10.27V2.25L.42,3.419A.668.668,0,0,0,0,4.039ZM4.01,10.27l4.01,1.337V3.587L4.01,2.25Zm7.562-8L8.689,3.587v8.02l2.922-1.169a.668.668,0,0,0,.42-.621V2.585A.334.334,0,0,0,11.572,2.274Z",
	transform: "translate(27.17 2.5)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_391",
	"data-name": "Path 391",
	className: "pointcloud-cls-4",
	d: "M513.384,173.935H489.392a3.214,3.214,0,0,0-3.211,3.211v12.738a3.214,3.214,0,0,0,3.211,3.211h23.992a3.214,3.214,0,0,0,3.211-3.211V177.146a3.215,3.215,0,0,0-3.211-3.211Z",
	transform: "translate(-395.944 -173.935)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_392",
	"data-name": "Path 392",
	className: "pointcloud-cls-5",
	d: "M506.279,193.435a.6.6,0,0,0-.6.6v12.738a.6.6,0,0,0,.6.6h23.992a.6.6,0,0,0,.6-.6V194.033a.6.6,0,0,0-.6-.6Z",
	transform: "translate(-412.83 -190.822)"
}), /* @__PURE__ */ React.createElement("text", {
	id: "_",
	"data-name": "+",
	className: "pointcloud-cls-7",
	transform: "translate(70.12 15)"
}, /* @__PURE__ */ React.createElement("tspan", {
	x: -3.705,
	y: 0
}, "+")), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_63",
	"data-name": "Ellipse 63",
	className: "pointcloud-cls-8",
	cx: 1,
	cy: 1,
	r: 1,
	transform: "translate(98.12 12)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_64",
	"data-name": "Ellipse 64",
	className: "pointcloud-cls-8",
	cx: 1,
	cy: 1,
	r: 1,
	transform: "translate(100.12 9)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_65",
	"data-name": "Ellipse 65",
	className: "pointcloud-cls-8",
	cx: 1,
	cy: 1,
	r: 1,
	transform: "translate(104.12 8)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_66",
	"data-name": "Ellipse 66",
	className: "pointcloud-cls-8",
	cx: 1,
	cy: 1,
	r: 1,
	transform: "translate(108.12 9)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_67",
	"data-name": "Ellipse 67",
	className: "pointcloud-cls-8",
	cx: 1,
	cy: 1,
	r: 1,
	transform: "translate(111.12 7)"
}));
export default SvgPointcloudOnly;
